import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppTest from './AppTest';

// Sentry.init({
//   dsn: "https://59bd4b7d7750ef8eea47443ae89ac0c0@o4510074332774400.ingest.us.sentry.io/4510074334478336",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   integrations: [
//     Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/mirchiexch\.com/,/^https:\/\/api\.mirchiexch\.com/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
//   // Enable logs to be sent to Sentry
//   enableLogs: true
// });

if (process.env.REACT_APP_BASE_URL === 'https://api.maruti.dev') {
  console.log = () => {}
  console.debug = () => {}
//   console.error = () => {}
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
reportWebVitals();
